enum CaseStatusType {
  Pending = 'Pending',
  Open = 'Open',
  Closed = 'Closed',
  Cancelled = 'Cancelled',
}

export default CaseStatusType;
